import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import "./footer.scss"

const Footer = () => {
  const footerLogos = useStaticQuery(graphql`{
  allFile(
    filter: {relativeDirectory: {eq: "footer"}, extension: {regex: "/(jpg)|(png)|(jpeg)/"}}
    sort: {base: DESC}
  ) {
    edges {
      node {
        base
        childImageSharp {
          gatsbyImageData(placeholder: NONE, formats: [WEBP], height: 25)
        }
      }
    }
  }
}`)

  const eighteenPlus = getImage(footerLogos.allFile.edges[4].node.childImageSharp.gatsbyImageData)
  const spelinspektionen = getImage(footerLogos.allFile.edges[2].node.childImageSharp.gatsbyImageData)
  const stodlinjen = getImage(footerLogos.allFile.edges[0].node.childImageSharp.gatsbyImageData)
  const spelpaus = getImage(footerLogos.allFile.edges[1].node.childImageSharp.gatsbyImageData)
  const c02neutral = getImage(footerLogos.allFile.edges[3].node.childImageSharp.gatsbyImageData)

  return (
    <footer>
      <div className="footer-columns-wrapper">
        <div className="footer-column one">
          <div className="footer-column-title">Hjälp och kontakt</div>
          <ul>
            <li><Link to="/om-oss/">Om oss</Link></li>
            <li><Link to="/kontakt/">Kontakt</Link></li>
            <li><Link to="/cookie-policy/">Användarvillkor & cookies</Link></li>
            <li><Link to="/faq/">FAQ</Link></li>
            <li><Link to="/sitemap-index.xml">Webbplatskarta</Link></li>
          </ul>
        </div>
        <div className="footer-column two">
          <div className="footer-column-title">Utforska</div>
          <ul>
            <li><Link to="/recensioner/">Recensioner</Link></li>
            <li><Link to="/spelautomater/">Slots</Link></li>
            <li><Link to="/tarningsspel/">Tärningsspel</Link></li>
            <li><Link to="/bingo/">Bingo</Link></li>
          </ul>
        </div>
        <div className="footer-column three">
          <div className="footer-column-title">Populära sidor</div>
          <ul>
            <li><Link to="/nyheter/">Nyheter</Link></li>
            <li><Link to="/artiklar/">Artiklar</Link></li>
            <li><Link to="/speltillverkare/">Speltillverkare</Link></li>
            <li><Link to="/betalningsmetoder/">Betalningsmetoder</Link></li>
          </ul>
        </div>
        <div className="footer-column three">
          <div className="footer-column-title">Sociala medier</div>
          <ul>
            <li><a href="https://www.facebook.com/alcasino.se" target="_blank" rel="noreferrer noopener">Facebook</a></li>
            <li><a href="https://www.youtube.com/channel/UCbD8LNCwwPsI_aT4OnI1iqg" target="_blank" rel="noreferrer noopener">YouTube</a></li>
            <li><a href="https://www.instagram.com/alcasino.se/" target="_blank" rel="noreferrer noopener">Instagram</a></li>
            <li><a href="https://twitter.com/AlcasinoS" target="_blank" rel="noreferrer noopener">Twitter</a></li>
          </ul>
        </div>
      </div>

      <div className="logotypes-wrapper">
        <div className="logotypes">
          <div className="logo-wrapper">
            <GatsbyImage image={eighteenPlus} alt="18+" className="eighteenPlus" />
          </div>
          <div className="logo-wrapper">
            <a href="https://www.spelinspektionen.se/" target="_blank" rel="noreferrer"><GatsbyImage image={spelinspektionen} alt="Spelinspektionen" className="spelinspektionen" /></a>
          </div>
          <div className="logo-wrapper">
            <a href="https://stodlinjen.se/" target="_blank" rel="noreferrer"><GatsbyImage image={stodlinjen} alt="Stödlinjen" className="stodlinjen" /></a>
          </div>

          <div className="logo-wrapper">
            <a href="https://www.spelpaus.se/" target="_blank" rel="noreferrer"><GatsbyImage image={spelpaus} alt="Spelpaus" className="spelpaus" /></a>
          </div>
          <div className="logo-wrapper"><a href="https://www.co2neutralwebsite.com/certificate/6272/sv" target="_blank" rel="noreferrer"><GatsbyImage image={c02neutral} alt="CO2neutral" className="co2neutral" /></a>
          </div >
        </div >
      </div >

      <div className="copyright-wrapper">
        <p>Alcasino.se är en oberoende jämförelsesida och guide för casinon på nätet i Sverige. Vi ägs av ICSU Media AB, ett svenskt företag med organisationsnummer 559279-9000. Observera att bonusar och kampanjer kan ändras, och som förmedlare kan vi inte ta ansvar för eventuella feltryck i informationen. Du måste vara 18 år eller äldre och bosatt i Sverige för att spela.</p>
        <p className="disclaimer">© 2025 Alcasino. Alla rättigheter förbehållna.</p>
      </div>
    </footer >
  )
}

export default Footer